/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NgModule } from "@angular/core";
import { HttpClientModule } from "@angular/common/http";
import { CoreModule } from "./@core/core.module";
import { ThemeModule } from "./@theme/theme.module";
import { AppComponent } from "./app.component";
import { AppRoutingModule } from "./app-routing.module";
import {
  NbChatModule,
  NbDatepickerModule,
  NbDialogModule,
  NbMenuModule,
  NbSidebarModule,
  NbToastrModule,
  NbWindowModule,
} from "@nebular/theme";
import { environment } from "../environments/environment";
import { AngularFireModule } from "@angular/fire";
import { AngularFireAuthModule } from "@angular/fire/auth";
import { AngularFirestoreModule } from "@angular/fire/firestore";
import { AngularFireDatabaseModule } from "@angular/fire/database";
import { AngularFireMessagingModule } from "@angular/fire/messaging";

import { NgxAuthModule } from "./@auth/auth.module";
import { ClipboardModule } from "ngx-clipboard";

import {
  AngularFireFunctionsModule,
  NEW_ORIGIN_BEHAVIOR,
  ORIGIN,
  REGION,
  USE_EMULATOR,
} from "@angular/fire/functions";
import { AngularFireStorageModule } from "@angular/fire/storage";

//firebase-initialization
import firebase from "firebase/app";
import "firebase/app-check";
const app = firebase.initializeApp(environment.firebase);
const appCheck = app.appCheck();
appCheck.activate(environment.recaptcha);
appCheck.setTokenAutoRefreshEnabled(true);

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,

    AngularFireModule.initializeApp(environment.firebase),
    AngularFireAuthModule,
    AngularFirestoreModule,
    AngularFireDatabaseModule,
    AngularFireFunctionsModule,
    AngularFireStorageModule,
    AngularFireMessagingModule,

    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(),
    NbToastrModule.forRoot(),

    CoreModule.forRoot(),
    ThemeModule.forRoot(),

    ClipboardModule,
    //Auth
    NgxAuthModule.forRoot(),
  ],
  providers: [
    { provide: REGION, useValue: environment.regionLocation },
    //{ provide: USE_EMULATOR, useValue: ["localhost", 5001] },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
